import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isLoggedIn } from './features/redux/sessionSlice';
import LoginRouter from './components/routers/LoginRouter';
import AppRouter from './components/routers/AppRouter';
import Notifications from './components/ui/Notifications/Notifications';
import Confirm from './components/ui/Confirm/Confirm';

function App() {
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(false)
  const loggedIn = useSelector(isLoggedIn)
  const [currentSession, setCurrentSession] = useState(null)
  
  // const [haveRecord, setHaveRecord] = useState(false)
  useEffect(() => {
    const iframe = document.getElementById('iframe');
    console.log(iframe);
    if (iframe) {
      iframe.addEventListener('load', () => {
        console.log(iframe);
        console.log(iframe.src);
        if(iframe.src && iframe.src.includes("vnc")) {
          setLoading(false)
        }
      })
    }
    
  },[])

  return (
    <div className="App">
      
      <BrowserRouter>
      {!loggedIn  ? <LoginRouter/> : <AppRouter/>}
      <Notifications />
      <Confirm />
    </BrowserRouter>
    
      
    </div>
  );
}

export default App;

